import { IconButton, ListItemIcon } from "@material-ui/core";
import { Grid, List, ListItem, ListItemText, Paper } from "@material-ui/core";
import { HomeWorkOutlined, PersonPin } from "@material-ui/icons";

import React from "react";
import {
  Route,
  useHistory,
  useLocation,
  useRouteMatch,
} from "react-router-dom";

import { officeAuth } from "../../redux/Login/LoginActionCreators";
import Store from "../../redux/Store";
import { sideStyles } from "../../styles/sideBarStyle";

import EditPersonalInfo from "./Edit_Personal_Info";
import OfficeInfo from "./Office_info";
import PersonalInfo from "./Personal_info";

const Profle = () => {
  const [edit, setEdit] = React.useState(false);

  const classes = sideStyles();
  const { path } = useRouteMatch();
  const history = useHistory();
  const location = useLocation();

  const pathNames = location.pathname.split("/").filter((x) => x);

  const clear = () => {
    history.push("/");
    localStorage.clear();
    Store.dispatch(officeAuth(false));
  };
  let profile;
  try {
    profile = JSON.parse(localStorage.profile);
    profile.last_state = profile.last_state === "active" ? "فعال" : "غیرفعال";
    profile.role = profile.role === "manager" ? "مدیر" : "کارمند";
    // profile.cDate = utils.today(new Date(profile.cDate));
  } catch (error) {
    clear();
  }

  return (
    <Grid
      item
      container
      xs={12}
      spacing={1}
      direction="row"
      style={{ margin: "auto", height: "100%" }}
    >
      {/* --------------------------------------------------------------------------------profile menu  */}
      <Grid item container xs={3} md={2} style={{}}>
        <Route path="/profile">
          <Paper style={{ width: "100%" }}>
            <List style={{ width: "100%" }}>
              {groups.map((item, index) => {
                return (
                  <ListItem
                    key={index}
                    onClick={() => history.push(`${path}/${item.link}`)}
                    button={
                      pathNames[pathNames.length - 1] === item.link
                        ? false
                        : true
                    }
                    className={
                      pathNames[pathNames.length - 1] === item.link
                        ? classes.activelistItem
                        : null
                    }
                  >
                    <ListItemIcon>
                      <IconButton
                        className={
                          pathNames[pathNames.length - 1].indexOf(item.link) >
                          -1
                            ? classes.activelistIcon
                            : null
                        }
                        color="primary"
                      >
                        {item.icon}
                      </IconButton>
                    </ListItemIcon>
                    <ListItemText>{item.title}</ListItemText>
                  </ListItem>
                );
              })}
            </List>
          </Paper>
        </Route>
      </Grid>
      <Grid item xs={9} md={10} style={{ height: "100%" }}>
        <Paper style={{ width: "100%", height: "100%" }}>
          <Route exact path="/profile/personal-info">
            {edit ? (
              <EditPersonalInfo
                setEdit={setEdit}
                profile={profile}
                clear={clear}
              />
            ) : (
              <PersonalInfo setEdit={setEdit} profile={profile} clear={clear} />
            )}
          </Route>
          <Route exact path="/profile/office-info">
            <OfficeInfo />
          </Route>
        </Paper>
      </Grid>
    </Grid>
  );
};

export default Profle;
const groups = [
  { title: "مشخصات فردی", link: "personal-info", icon: <PersonPin /> },
  { title: "مشخصات دفتر", link: "office-info", icon: <HomeWorkOutlined /> },
];
